import { UrlRegex } from '../url';
import { INT_PHONE_REGEX } from '../constants';

export const OptionalPhoneNumberProperty = {
  required: false,
  type: 'string',
  // eslint-disable-next-line no-useless-escape
  pattern: /^((\+0?\d{1,3}\s)?((\s|\(|\))*\-*\d){8,10})?$/,
};

export const OptionalAddressSuggestionOptionProperty = {
  type: 'string',
  required: false,
};

export const CampaignValidationSchema = {
  name: 'Campaign',
  type: 'object',
  properties: {
    campaignName: {
      type: 'string',
      maxLength: 125,
      required: true,
      distinguishWideChar: true,
    },
    socialProfile: {
      required: true,
      type: 'string',
      pattern: /^\d+$/,
    },
    website: {
      required: true,
      type: 'string',
      pattern: UrlRegex,
      maxLength: 253,
    },
    categories: {
      type: 'array',
      minItems: 1,
      maxItems: 10,
    },
    businessName: {
      type: 'string',
      maxLength: 80,
      required: true,
      distinguishWideChar: true,
    },
    businessPhoneNumber: {
      required: true,
      type: 'string',
      maxLength: 20,
      pattern: INT_PHONE_REGEX,
    },
    businessCountryCode: {
      type: 'string',
      required: true,
    },
    businessProviceName: {
      type: 'string',
      required: true,
    },
    businessStreetAddress1: {
      type: 'string',
      required: true,
    },
    businessCity: {
      type: 'string',
      required: true,
    },
    businessPostalCode: {
      type: 'string',
      required: true,
    },
  },
};
